/**
 * Trial Controller
 *  
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */     
define(function(require) {
    'use strict';
    
    // CORE
    var LE = require('app');
    var Loader = require("ui/loader/Loader");

    // CONTROLLER

    // MODEL
    var AccountModel = require("registration-models/AccountModel");
    var BaseModel = require("models/BaseModel");

    // VIEW
    var RegistrationSignUpView =        require("registration-views/RegistrationSignUpView");
    var RegistrationCreateAccountView = require("registration-views/RegistrationCreateAccountView");
    var RegistrationThankYouView =      require("registration-views/RegistrationThankYouView");

    // UTILS
    var RegistrationObjectUtil = require("registration-utils/RegistrationObjectUtil");


    var TrialController = {};
    LE.module("LERegistration", function (LERegistration, LE, Backbone, Marionette, $, _) {
        TrialController = Marionette.Controller.extend({
            
            initialize: function (options) {
                LERegistration.logger.info("TrialController initialize");

                this.vent = options.vent;
                this.controller = options.controller;

            },

            //-------------------------------------------------------------------------
           
            showSignUpView: function(){    
                LERegistration.logger.info("Showing the signup email page","TrialController:showSignUpView");

                var view = new RegistrationSignUpView({ model: this.controller.registrationVerificationModel });
                this.controller.showViewInMainRegion(view);
            },

            showCreateAccountView: function (paramsObject){
                LERegistration.logger.info("Showing the create account form","TrialController:showCreateAccountView");
                var info = RegistrationObjectUtil.buildAccountModelAttributes(paramsObject);        
                var accountModel = new AccountModel();
                accountModel.set(info);

                var registrationCreateAccountModel = new BaseModel();
                registrationCreateAccountModel.set({
                    "language":paramsObject.language,
                    "token":paramsObject.token,
                    "tier":paramsObject.tier,
                    "frequency":paramsObject.frequency
                });
                var registrationCreateAccountView = new RegistrationCreateAccountView({   
                    model:                          accountModel,
                    registrationCreateAccountModel: registrationCreateAccountModel,
                    automationSecret:               paramsObject.automationSecret
                });
                this.controller.showViewInMainRegion(registrationCreateAccountView);
            },

            showThankYouView: function (){
                LERegistration.logger.info("Showing the signup thank you page", "TrialController:showThankYouView");
                var registrationThankYouView = new RegistrationThankYouView({ model: this.controller.registrationVerificationModel});
                this.controller.showViewInMainRegion(registrationThankYouView, false, "#registration!thankYou");
            }
            

           
            
        });
     
       

    });
    return TrialController;
});